import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";

const navLinks = [
  { label: "Det jeg tror på", href: "#tror" },
  { label: "Coaching", href: "#coaching" },
  { label: "Undervisning", href: "#undervisning" },
  { label: "Inspiration", href: "#inspiration" },
  { label: "Det andre synes", href: "#mennesket" },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logoImage, setLogoImage] = useState(null);

  useEffect(() => {
    const existingLogo = localStorage.getItem('uploaded_logo');
    if (existingLogo) {
      setLogoImage(existingLogo);
    }
    const handleImageUpload = (event) => {
      if (event.detail.type === 'logo') {
        setLogoImage(event.detail.base64);
      }
    };
    window.addEventListener('imageUploaded', handleImageUpload);
    return () => window.removeEventListener('imageUploaded', handleImageUpload);
  }, []);

  return (
    <nav className="bg-sage/95 backdrop-blur-sm border-b border-sage-dark sticky top-0 z-50 transition-all duration-300" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center navbar-logo">
            {logoImage ? (
              <img src={logoImage} alt="Stine Eskesen Logo" className="h-12 w-auto" />
            ) : (
              <a href="#home" className="font-heading text-2xl font-semibold text-charcoal tracking-tight" data-testid="navbar-brand">
                Stine Eskesen
              </a>
            )}
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex flex-1 items-center justify-center space-x-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-base text-charcoal/70 hover:text-charcoal transition-colors duration-200 font-medium"
                data-testid={`nav-link-${link.href.slice(1)}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <a href="#contact" data-testid="nav-kontakt-cta">
              <Button className="bg-terracotta hover:bg-terracotta-dark text-white px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105">
                Kontakt
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-charcoal/70 hover:text-charcoal transition-colors"
              data-testid="mobile-menu-button"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 border-t border-taupe mt-4 pt-4" data-testid="mobile-menu">
            <div className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-base text-charcoal/70 hover:text-charcoal transition-colors font-medium"
                  data-testid={`mobile-nav-link-${link.href.slice(1)}`}
                >
                  {link.label}
                </a>
              ))}
              <a href="#contact" onClick={() => setIsMenuOpen(false)}>
                <Button className="bg-terracotta hover:bg-terracotta-dark text-white px-6 py-2 rounded-full w-fit">
                  Kontakt
                </Button>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
